<template>
  <BreadCrumb PageTitle="Return Orders List" />
  <ReturnOrdersList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../components/Common/BreadCrumb.vue";
import ReturnOrdersList from "../components/ReturnOrders/ReturnOrdersList.vue";

export default defineComponent({
  name: "ReturnOrdersListPage",
  components: {
    BreadCrumb,
    ReturnOrdersList,
  },
});
</script>